import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { TopicFilterNames } from 'components/TopicFilters/shared';
import { EntityTypes } from 'context/entityContext';
import getRegionBreakdown from 'helpers/getRegionBreakdown';
import getCountryIds from 'helpers/getCountryIds';

interface IDownloadKPIURLArgs {
  countryIds?: string[];
  customerFilter?: TopicFilterNames[];
  download?: boolean;
  entityType: EntityTypes;
  entityIds: string[];
  mediaTypes?: string;
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
}

export default function getDownloadKPIURL(args: IDownloadKPIURLArgs): string {
  const {
    countryIds,
    customerFilter,
    download,
    entityType,
    entityIds,
    mediaTypes,
    region,
    compareMode,
    customRegion,
  } = args;
  const type = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    customerFilter,
    download,
    mediaTypes,
    regionBreakdown: getRegionBreakdown(
      countryIds,
      region,
      compareMode,
      customRegion
    ),
  });

  return `/api/downloads/kpi/${type}/${entityIds}?${params}`;
}
